import * as swcHelpers from '@swc/helpers';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import 'react';
import '@grandvisionhq/analytics';
import 'classnames';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import { ProductRecommendationAction, BannerRecommendationAction } from '../../ProductBlock/types.js';
import '@grandvisionhq/frk-routing';
import { createResponsiveImage } from '../../ProductBlock/utils/get-variant-images.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/api-client';

const convertProductRecommendationInfo = (recommendation, url)=>{
    var ref;
    if (!CommerceToolsApi.isProductTypeName(recommendation.productType)) {
        console.error(`Recommendation has invalid product type name "${recommendation.productType}"`);
        return;
    }
    const images = recommendation.images.reduce((m, image)=>!image.label || !image.dimension ? m : [
            ...m,
            {
                url: image.url,
                label: image.label,
                dimensions: {
                    w: image.dimension.width,
                    h: image.dimension.height
                }
            }, 
        ]
    , []);
    var _label;
    const front = images[0] ? createResponsiveImage(images[0].url, (_label = images[0].label) !== null && _label !== void 0 ? _label : undefined) : undefined;
    var _label1;
    const angle = images[1] ? createResponsiveImage(images[1].url, (_label1 = images[1].label) !== null && _label1 !== void 0 ? _label1 : undefined) : undefined;
    var _action;
    const action = getProductRecommendationAction((_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined);
    const slug = recommendation.action && action === ProductRecommendationAction.Redirect && 'slug' in recommendation.action && recommendation.action.slug;
    return swcHelpers.objectSpread({
        sku: recommendation.sku,
        brand: recommendation.brand,
        url,
        images: {
            front,
            angle
        },
        productType: recommendation.productType,
        name: recommendation.name || recommendation.brandModel || '',
        price: recommendation.price.value.centAmount,
        discountedPrice: (ref = recommendation.price.discounted) === null || ref === void 0 ? void 0 : ref.value.centAmount,
        tags: recommendation.tags,
        action
    }, slug && {
        slug
    }, recommendation.promotionLabel && {
        promotionLabel: recommendation.promotionLabel
    });
};
const convertBannerRecommendationInfo = (recommendation)=>{
    const responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
    var _action;
    const action = getBannerRecommendationAction((_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined);
    const link = recommendation.action && action === BannerRecommendationAction.Link && 'link' in recommendation.action && recommendation.action.link;
    const discountCode = recommendation.action && action === BannerRecommendationAction.DiscountCode && 'discountCode' in recommendation.action && recommendation.action.discountCode;
    return swcHelpers.objectSpread({
        title: recommendation.title,
        description: recommendation.description,
        image: {
            url: responsiveImage.url,
            mobileUrl: responsiveImage.url,
            description: recommendation.description
        },
        action
    }, link && {
        link
    }, discountCode && {
        discountCode
    });
};
const getProductRecommendationAction = (action)=>{
    if (!action) {
        return;
    }
    if ('hasQuantitySelector' in action && 'sku' in action) {
        return action.hasQuantitySelector ? ProductRecommendationAction.AddQuantity : ProductRecommendationAction.AddToCart;
    }
    if ('slug' in action) {
        return ProductRecommendationAction.Redirect;
    }
};
const getBannerRecommendationAction = (action)=>{
    if (!action) {
        return;
    }
    if ('link' in action) {
        return BannerRecommendationAction.Link;
    }
    if ('discountCode' in action) {
        return BannerRecommendationAction.DiscountCode;
    }
};

export { convertBannerRecommendationInfo, convertProductRecommendationInfo, getProductRecommendationAction };
//# sourceMappingURL=mappers.js.map
